const tabConfig = {
    tabs: [
        {
            id: '1',
            radio: 'radio-2',
            intent: 'PromptEmbeddings',
            label: 'tabDocuments',
            icon: 'description',
            accessKey: 'DocumentsAccess',
                        dropdownItems: []
        },
        {
            id: '2',
            radio: 'radio-3',
            intent: 'PromptGpt',
            label: 'tabChat',
            icon: 'contact_support',
            accessKey: 'ChatAccess',
            dropdownItems: [
                { id: 0, name: "GPT-5.4-mini" },
                { id: 1, name: "GPT-5.4" }
                        ]
        }
    ]
};

export default tabConfig;